import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
  },
});
